<template>
  <v-container>
    <v-card v-if="isList">
      <v-card-title class="mb-3">
        <span class="text-h6">Ventas</span>
        <v-spacer></v-spacer>
        <v-btn
          title="Nueva Venta"
          small
          color="primary"
          @click="openViewNewSale"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="sales"
        item-value="id"
        dense
        class="elevation-1"
        :search="search"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="Buscar"
            outlined
            dense
            class="mx-4 small-input"
          ></v-text-field>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn icon @click="openDialog('edit', item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.plate="{ item }">
          {{ item.vehicle.plate }}
        </template>
        <template v-slot:item.dateFormat="{ item }">
          {{ item.sale_date }}
        </template>
      </v-data-table>
    </v-card>

    <!-- FORMULARIO EDITA O CREA VENTA -->
    <v-card v-else class="mx-10">
      <v-card-title class="mb-3">
        <span class="text-h6">{{ dialogTitle }} Venta</span>
        <v-spacer></v-spacer>
        <v-btn title="Listado" small color="primary" @click="isList = true">
          <v-icon>mdi-list-box</v-icon>
        </v-btn>
      </v-card-title>

      <!--Formulario nueva venta-->
      <v-form ref="form">
        <v-row justify="center" align="center" class="px-10">
          <v-col cols="5">
            <v-text-field
              v-model="vehicleSelected.make"
              label="MARCA"
              outlined
              dense
              hide-details
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="vehicleSelected.model"
              label="MODELO"
              outlined
              dense
              hide-details
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="1">
            <v-btn
              title="Agregar Vehículo"
              icon
              color="primary"
              @click="openVehicleModal"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="1">
            <v-btn
              title="Buscar Vehículo"
              icon
              color="primary"
              @click="searchVehicle"
            >
              <v-icon>mdi-car-search</v-icon>
            </v-btn>
          </v-col>
          <v-divider class="my-4"></v-divider>
          <!-- Cliente con búsqueda y modal -->
          <v-col cols="10">
            <v-text-field
              v-model="dni"
              label="DNI"
              outlined
              dense
              hide-details
              @keyup.enter="fetchClient"
            ></v-text-field>
          </v-col>
          <v-col cols="1">
            <v-btn
              title="Agregar Cliente"
              icon
              color="primary"
              @click="openClientModal"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="1">
            <v-btn
              title="Buscar Cliente"
              icon
              color="primary"
              @click="searchClient"
            >
              <v-icon>mdi-account-search</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="completeName"
              label="NOMBRE"
              outlined
              dense
              hide-details
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="clientSelected.address"
              label="DIRECCION"
              outlined
              dense
              hide-details
              disabled
            ></v-text-field>
          </v-col>
          <!-- Precio -->
          <v-col cols="6">
            <v-text-field
              v-model="price"
              label="PRECIO"
              type="number"
              required
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- Campo de Fecha -->
            <v-text-field
              class="small-input"
              v-model="date"
              type="date"
              label="Fecha"
              :rules="[rules.required]"
              outlined
              dense
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-overlay :value="overlay" :z-index="3000">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-form>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="isEdit" color="primary" @click="updateSale">
          {{ "Editar" }}</v-btn
        >
        <v-btn v-else color="primary" :disabled="isDisable" @click="saveSale">
          {{ "Guardar" }}</v-btn
        >
      </v-card-actions>
      <!-- Modal para agregar Cliente -->
      <ClientDialog v-model="clientModal" @save-client="onClientSaved" />
      <!-- Modal para agregar Vehículo -->
      <v-dialog v-model="vehicleModal" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Agregar Vehículo</v-card-title>
          <v-card-text>
            <VehicleForm
              ref="vehicleForm"
              mode="add"
              source="venta"
              :vehicleData="vehicle"
              :visibleFields="visibleFields"
              @save="addVehicle"
              @close="vehicleModal = false"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
    <!-- Modal para buscar Vehículo -->
    <v-dialog v-model="searchVehicleDialog" max-width="800px">
      <v-card>
        <v-card-title class="headline">Seleccionar Vehículo</v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersVehicle"
            :items="vehicles"
            item-value="id"
            dense
            class="elevation-1"
            :search="searchVeh"
          >
            <template v-slot:top>
              <v-text-field
                v-model="searchVeh"
                label="Buscar"
                outlined
                dense
                class="mx-4 small-input"
              ></v-text-field>
            </template>
            <template v-slot:item="{ item }">
              <tr @click="selectVehicle(item)" class="clickable-row">
                <td>{{ item.plate }}</td>
                <td>{{ item.make }}</td>
                <td>{{ item.model }}</td>
                <td>{{ item.year }}</td>
                <td>{{ item.version }}</td>
                <td>{{ item.color }}</td>
                <td>{{ item.chassis_number }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="searchVehicleDialog = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Modal para buscar Cliente -->
    <v-dialog v-model="searchClientDialog" max-width="800px">
      <v-card>
        <v-card-title class="headline">Seleccionar Cliente</v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersClient"
            :items="clients"
            item-value="id"
            dense
            class="elevation-1"
            :search="searchCli"
          >
            <template v-slot:top>
              <v-text-field
                v-model="searchCli"
                label="Buscar"
                outlined
                dense
                class="mx-4 small-input"
              ></v-text-field>
            </template>
            <template v-slot:item="{ item }">
              <tr @click="selectClient(item)" class="clickable-row">
                <td>{{ item.dni }}</td>
                <td>{{ item.first_name }}</td>
                <td>{{ item.last_name }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.phone }}</td>
                <td>{{ item.address }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="searchVehicleDialog = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="showErrorSnackbar"
      :timeout="snackbarTimeout"
      color="red darken-2"
      top
      right
      multi-line
    >
      <div v-for="(error, index) in errors" :key="index">
        {{ error }}
      </div>
    </v-snackbar>
    <v-overlay :value="overlay" :z-index="3000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
      
      <script>
import axios from "@/plugins/axios.js";
import VehicleForm from "@/components/VehicleForm.vue";
import client from "@/components/Client.vue";
import ClientDialog from "@/components/Client.vue";
export default {
  components: { VehicleForm, client, ClientDialog },
  data() {
    return {
      headersVehicle: [
        { text: "Patente", value: "plate" },
        { text: "Marca", value: "make" },
        { text: "Modelo", value: "model" },
        { text: "Año", value: "year" },
        { text: "Serie", value: "version" },
        { text: "Color", value: "color" },
        { text: "Chasis", value: "chassis_number" },
        //{ text: "Precio", value: "price" },
      ],
      headersClient: [
        { text: "Dni", value: "dni" },
        { text: "Nombre", value: "first_name" },
        { text: "Apellido", value: "last_name" },
        { text: "Correo Electrónico", value: "email" },
        { text: "Teléfono", value: "phone" },
        { text: "Dirección", value: "address" },
      ],
      clientModal: false,
      vehicleModal: false,
      price: null,
      date: "",
      rules: {
        required: (v) => !!v || "Este campo es obligatorio",
      },
      client: {},
      plate: null,
      dni: null,
      vehicleSelected: {
        id: null,
        make: null,
        model: null,
      },
      clientSelected: {
        id: null,
        make: null,
        model: null,
      },
      sale: {
        id: null,
        price: null,
        sale_date: null,
      },

      isList: true,
      isEdit: false,
      search: "",
      searchVeh: "",
      searchCli: "",
      dialog: false,
      dialogTitle: "Nueva",
      headers: [
        { text: "#", value: "id" },
        { text: "VEHICULO", value: "vehicle.model" },
        { text: "Patente", value: "plate" },
        //{ text: "Precio", value: "price" },
        { text: "Fecha", value: "dateFormat" },
        { text: "Cliente", value: "clientFullName" },
        { text: "Action", value: "action" },
      ],
      vehicles: [],
      clients: [],
      vehicle: {
        id: null,
        make: "",
        model: "",
        year: "",
        version: "",
        plate: "",
        color: "",
        price: 0,
        position: "",
        factory_id: "",
        vin: "",
        motor_number: "",
        chassis_make: "",
        motor_make: "",
        certificate_number: "",
        body_type: "",
      },
      action: "", // 'add' o 'edit'
      overlay: false,
      roles: [],
      searchVehicleDialog: false,
      searchClientDialog: false,
      sales: [],
      visibleFields: [
        "make",
        "model",
        "year",
        "plate",
        "chassis_make",
        "chassis_number",
        "color",
        "motor_make",
        "motor_number",
        "certificate_number",
        "body_type",
        //"status",
      ],
      errors: [],
      showErrorSnackbar: false,
      snackbarTimeout: 6000, // tiempo visible en ms: [],
    };
  },
  computed: {
    user() {
      return this.$store.getters["auth/getUser"];
    },
    completeName() {
      if (!this.clientSelected.first_name) return null;
      return `${this.clientSelected.first_name} ${
        this.clientSelected.last_name ?? ""
      }`;
    },
    isDisable() {
      return (
        this.date == "" ||
        this.completeName == null ||
        this.vehicleSelected.make == null
      );
    },
  },
  mounted() {
    this.getSales();
  },
  methods: {
    onClientSaved(resp) {
      const client = resp.client;
      this.clientSelected = client;
      this.dni = this.clientSelected.dni;
      this.clientModal = false;
      this.overlay = false;
    },
    selectVehicle(vehicle) {
      this.vehicleSelected = vehicle;
      this.searchVehicleDialog = false;
    },
    selectClient(client) {
      this.clientSelected = client;
      this.dni = client.dni;
      this.searchClientDialog = false;
    },
    fetchClient() {
      this.overlay = true;
      axios
        .get("/clients/getClient", {
          params: {
            dni: this.dni,
          },
        })
        .then((response) => {
          if (!response.data) {
            //msg de aviso para realizar carga
            return;
          }
          this.clientSelected = response.data;
        })
        .catch((err) => {
          console.error("Error al obtener recursos:", err);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    addVehicle(data) {
      this.vehicle = data;
      this.overlay = true;
      axios
        .post("vehicles/register", this.vehicle)
        .then((response) => {
          this.vehicleSelected = response.data.vehicle;
          this.plate = this.vehicleSelected.plate;
          this.vehicleModal = false;
          this.overlay = false;
          //this.clearForm();
        })
        .catch((err) => {
          this.overlay = false;
          this.errors = [];
          if (err.response && err.response.status === 422) {
            const serverErrors = err.response.data.errors;
            for (let field in serverErrors) {
              this.errors.push(...serverErrors[field]);
            }
          } else {
            this.errors.push(
              "Ocurrió un error inesperado al guardar el vehículo."
            );
            console.error(err);
          }
          this.showErrorSnackbar = true;
        });
    },
    getSales() {
      this.overlay = true;
      axios
        .get("/sales/getSales")
        .then((response) => {
          this.sales = response.data.map((sale) => {
            const [datePart] = sale.sale_date.split(" ");
            const [day, month, year] = datePart.split("/").map(Number);
            const fullYear = year < 100 ? 2000 + year : year;
            const dateObj = new Date(
              fullYear,
              month - 1,
              day
            );            
            return {
              ...sale,
              plate: sale.vehicle.plate,
              dateFormat: dateObj.getTime(),
              clientFullName: `${sale.client?.first_name ?? ""} ${
                sale.client?.last_name ?? ""
              }`
                .trim()
                .toLowerCase(),
            };
          });
          this.overlay = false;
        })
        .catch(() => {
          this.overlay = false;
        });
    },
    saveSale() {
      this.overlay = true;
      axios
        .post("sales/register", {
          vehicleId: this.vehicleSelected.id,
          clientId: this.clientSelected.id,
          date: this.date,
          price: this.price,
          userId: this.user.id,
        })
        .then((response) => {
          this.getSales();
          this.isList = true;
          this.overlay = false;
        })
        .catch((err) => {
          console.log(err.response.data.error);
          this.overlay = false;
        });
    },

    incrementarAño(fechaStr) {
      const partes = fechaStr.split("-"); // separa por guiones
      const año = parseInt(partes[0]); // convierte el año a número
      partes[0] = (año + 1).toString(); // suma 1 y vuelve a string
      return partes.join("-"); // vuelve a unirlo
    },
    updateSale() {
      this.sale.price = this.price;
      this.sale.sale_date = this.date;
      this.overlay = true;
      axios
        .put("sales/update", {
          sale: this.sale,
          vehicleId: this.vehicleSelected.id,
          clientId: this.clientSelected.id,
        })
        .then((response) => {
          this.getSales();
          this.isList = true;
          this.overlay = false;
          //this.clearForm();
        })
        .catch((err) => {
          //console.log(err.response.data.error);
          this.overlay = false;
        });
    },
    searchVehicle() {
      this.searchVehicleDialog = true;
      this.getVehicles();
    },
    getVehicles() {
      this.overlay = true;
      axios
        .get("/vehicles/getVehicles", {
          params: {
            filterData: ["salon"],
          },
        })
        .then((response) => {
          this.vehicles = [...response.data];
          this.overlay = false;
        })
        .catch((err) => {
          this.overlay = false;
        });
    },
    searchClient() {
      this.searchClientDialog = true;
      this.getClients();
    },
    getClients() {
      this.overlay = true;
      axios
        .get("/clients/getClients")
        .then((response) => {
          this.clients = [...response.data];
          this.overlay = false;
        })
        .catch(() => {
          this.overlay = false;
        });
    },
    openClientModal() {
      this.clientModal = true;
    },
    openVehicleModal() {
      this.$nextTick(() => {
        if (this.$refs.vehicleForm) {
          this.$refs.vehicleForm.clear();
        }
      });
      this.vehicleModal = true;
    },
    openViewNewSale() {
      this.clearFormSale();

      this.isList = false;
      this.isEdit = false;
      this.dialogTitle = "Nueva";
    },
    openDialog(action, sale = null) {
      this.action = action;
      this.clearFormSale();
      if (this.action === "edit") {
        this.sale.id = sale.id;
        this.price = sale.price;
        this.date = sale.sale_date;
        this.selectVehicle(sale.vehicle);
        this.selectClient(sale.client);
      }
      this.dialog = true;
      this.dialogTitle = action === "edit" ? "Editar" : "Nueva";
      this.isList = false;
      this.isEdit = true;
    },

    clearFormSale() {
      this.sale = {
        id: null,
        price: null,
        sale_date: null,
      };

      this.vehicleSelected = {
        id: null,
        make: null,
        model: null,
      };

      this.clientSelected = {
        id: null,
        make: null,
        model: null,
      };
      this.price = null;
      this.date = "";
      this.dni = null;
    },
  },
};
</script>
    
    <style scoped>
/* Estilo para que la fila cambie de color al pasar el mouse */
.clickable-row {
  cursor: pointer;
  transition: background 0.2s;
}
.clickable-row:hover {
  background-color: #e0f7fa; /* Azul claro */
}
/* Estilo para reducir la altura del input */
.small-input .v-input__control {
  height: 30px !important; /* Ajusta la altura */
  font-size: 9pt; /* Ajusta el tamaño del texto */
  padding: 4px 8px !important; /* Reduce el padding interno */
}
.small-input .v-label {
  font-size: 0.75rem; /* Reduce el tamaño de la etiqueta */
  top: -6px; /* Ajusta la posición de la etiqueta */
}
</style>
      